import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-collapse';

class Instructions extends Component {
  static propTypes = {
    collapseOnRest: PropTypes.func.isRequired, // callback for when the collapse container finishes animating
    handleClick: PropTypes.func.isRequired, // callback that sets state for isOpened in Sidebar
    isOpened: PropTypes.bool.isRequired, // should the collapsable container be opened or closed
  };

  constructor() {
    super();
    this.instructions = null;
  }

  render() {
    const { collapseOnRest, handleClick, isOpened } = this.props;
    const btmClassName = isOpened ? 'bottom opened' : 'bottom';

    return (
      <div
        ref={_ => {
          this.instructions = _;
        }}
        className="Instructions"
      >
        <Collapse isOpened={isOpened} onRest={() => collapseOnRest(this.instructions)}>
          <p>
            <strong>Select a topic</strong> to explore data layers and learn about the world's most
            threatened forest ecosystems.
          </p>
        </Collapse>
        <div className={btmClassName}>
          <button className="close" onClick={handleClick}>
            {isOpened ? (
              <i className="fa fa-angle-up" aria-hidden="true" />
            ) : (
              <i className="fa fa-angle-down" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>
    );
  }
}

export default Instructions;



// WEBPACK FOOTER //
// ./src/components/Instructions.jsx